import classNames from 'classnames';
import { object, shape } from 'prop-types';
import React, { useCallback } from 'react';
import DropDown from '../../drop-down';
import { SkjemaSporsmal } from '../../ahv-schema';
import { PAKREVET_HVIS_FORELDER, SPORSMAL_PAKREVET, BARE_LES_NAR_VALGT } from '../../constants/general';
import { getIsDisabled } from '../../form-util';
import { getPreselected, isRequiredWhenSelected } from '../helper/component-helper';
import connect from '../helper/connect';
import ErrorMessage from '../errormessage';
/* eslint-disable react-hooks/exhaustive-deps */

const DEFAULT_VELG_OPTION_VALUE = '0';

function SelectQuestionType(props) {
    const { question, context } = props;
    const { definisjon, instruks, utfyllingsregel, muligeSvar } = question;
    const isRequired =
        (utfyllingsregel &&
            [SPORSMAL_PAKREVET, BARE_LES_NAR_VALGT, PAKREVET_HVIS_FORELDER].includes(utfyllingsregel.regel)) ||
        false;
    const hasInvalidValue = isRequired && context.hasError(definisjon);

    const getDropDownValues = useCallback(() => {
        return muligeSvar.map((muligSvar) => {
            const { svarId, tekst } = muligSvar;
            return { value: svarId, text: tekst };
        });
    }, [muligeSvar]);

    const getSelected = () => {
        const selectedValue = context.getValue(definisjon)[0];
        return Array.isArray(selectedValue) ? DEFAULT_VELG_OPTION_VALUE : selectedValue || DEFAULT_VELG_OPTION_VALUE;
    };

    const hasError = useCallback(
        (value) => {
            if (!value) {
                value = context.getValue(definisjon);
            }
            return value.length === 0 || value === DEFAULT_VELG_OPTION_VALUE;
        },
        [context, definisjon]
    );

    const preselected = getPreselected(question);

    const selected = getSelected();

    const selectValue = useCallback(
        (e) => {
            context.onChange(definisjon, { value: [e], error: hasError(e) });
        },
        [context, definisjon, hasError]
    );

    const removeValue = useCallback(() => {
        context.removeValue(definisjon);
    }, [context, definisjon]);

    const handleBlur = useCallback(() => {
        if (selected !== DEFAULT_VELG_OPTION_VALUE && isRequiredWhenSelected(question)) {
            context.updateValidation(definisjon, true, hasError());
        }
    }, [context, definisjon, selected, hasError, question]);

    return (
        <div className={hasInvalidValue ? 'has-error error' : ''}>
            <DropDown
                disabled={getIsDisabled(utfyllingsregel.regel, preselected, context.getRolle())}
                className={classNames('form-control', { 'has-error error': hasInvalidValue })}
                values={getDropDownValues()}
                selected={selected}
                label={null}
                errortext={null}
                selectValue={selectValue}
                onBlur={handleBlur}
                removeValue={removeValue}
            />
            {hasInvalidValue && <ErrorMessage text={instruks} />}
        </div>
    );
}

SelectQuestionType.propTypes = {
    question: shape(SkjemaSporsmal).isRequired,
    context: object,
};

export default connect(React.memo(SelectQuestionType));
